/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Smarts
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
'use strict'

import { UNKNOWN_CONCEPT } from '../Concept'
import conceptsRegistry from '../ConceptsRegistry'

/**
 * Utility class to provid convenient methods for Concept
 */
export default class ConceptsUtil {
	/**
     * return the registerd concept name for the IRI
     * @param iri the IRI of the concept
     * @return the name of founded concept, empty string if not find
     */
	static getConceptName(iri){
		if (!iri) {
			return UNKNOWN_CONCEPT.getName()
		}

		return conceptsRegistry.getConcept(iri).getName()
	}

	/**
     * return the registerd concept ontology ID for the IRI
     * @param iri the IRI of the concept
     * @return the ontology ID of founded concept, empty string if not find
     */
	static getOnotlogyId(iri){
		if (!iri) {
			return UNKNOWN_CONCEPT.getOntologyID()
		}

		return conceptsRegistry.getConcept(iri).getOntologyID()
	}
}